import { render, staticRenderFns } from "./FileType.vue?vue&type=template&id=34a93517&scoped=true&"
import script from "./FileType.vue?vue&type=script&lang=ts&"
export * from "./FileType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a93517",
  null
  
)

export default component.exports